import { Position } from 'reactflow'
import { useContext } from 'react'
import { IOHandle, hasNextNode } from './common'
import { CampaignContext, ICampaignContext } from '@/expr/Context'
import { isCustomEvent } from '../Settings'
import { IBlockProps } from '../types'
import { NextNode } from '../components/NextNode/NextNode'
import { useTranslation } from 'react-i18next'

export const START_BLOCK_WIDTH = 228

export default function StartBlock(props: IBlockProps) {
  const context = useContext(CampaignContext) as ICampaignContext
  const { t } = useTranslation()

  return (
    <>
      <IOHandle color={'transparent'} position={Position.Top} type="target" id="input" />
      <div
        className="relative flex h-[44px] items-center justify-center rounded-full bg-fg-brand-primary p-4"
        style={{
          width: START_BLOCK_WIDTH + 'px',
        }}
      >
        <p className="text-center text-title-t6 text-fg-primary">
          {isCustomEvent(context.campaign.type) ? context.campaign.type : t(`campaign.type.${context.campaign.type}`)}
        </p>

        <NextNode {...props} />
      </div>
      <IOHandle
        position={Position.Bottom}
        hasNext={hasNextNode(props.data.graph, props.data.node)}
        type="source"
        id="output"
      />
    </>
  )
}
